import { render, staticRenderFns } from "./related-posts.vue?vue&type=template&id=9fcbc7ca"
import script from "./related-posts.vue?vue&type=script&lang=js"
export * from "./related-posts.vue?vue&type=script&lang=js"
import style0 from "./related-posts.vue?vue&type=style&index=0&id=9fcbc7ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports